
import alert from './alert'
import cashControl from './cashControl'
import catalog from './catalog'
import customers from './customers'
import dashboard from './dashboard'
import fiscalCountry from './fiscalCountry'
import help from './help'
import history from './history'
import icons from './icons'
import inOut from './in-out'
import loading from './loading'
import orders from './orders'
import purchase from './purchase'
import rummage from './rummage'
import settings from './settings'
import sync from './sync'
import user from './user'
import workingModes from './working-modes'

export default {
  alert,
  cashControl,
  catalog,
  customers,
  dashboard,
  fiscalCountry,
  help,
  history,
  icons,
  inOut,
  loading,
  orders,
  purchase,
  rummage,
  settings,
  sync,
  user,
  workingModes,
}
